import {flow, getEnv, types} from "mobx-state-tree";
import MediaFileStore from "../../stores/domain/MediaFileStore";

export const MediaFilesList  = types.model('MediaFilesList ', {
        store: types.maybe(types.late(() => types.reference(MediaFileStore))),
        isLoading: types.optional(types.boolean, false), //types.enumeration('State', ['pending', 'done', 'error']),
        page: types.optional(types.integer, 1),
        perPage: types.optional(types.integer, 10),
        totalRows: types.optional(types.integer, 0),
        sortOrder: types.optional(types.string, "desc"),
        sortField:  types.optional(types.string, "updatedAt"),

    })
    .volatile(self => ({
        searchParams: {},
        filters: {}
    })).actions((self) => ({
        setSortOrder(sortDirection) {
          self.sortOrder = sortDirection
        },
        setSortField(sortField) {
          self.sortField = sortField
        },
        fetchAll: flow(function* fetchAll(sortParams = {}) {
          self.items = []
          self.isLoading = true
          if (Object.keys(sortParams).length === 0) {
            sortParams = {
              sort: 'updatedAt',
              order: self.sortOrder
            };
          }
          try {

              const queryParams = {
                  page: self.page,
                  perPage: self.perPage,
                  ...sortParams,
                  ...self.searchParams
              }

              const manager = getEnv(self).mediaFileManager
              console.log("queryParams in fetchAll mediaFiles",queryParams)
              const response = yield manager.fetchAll(queryParams);
              if(response != null) {
                  console.log("response.results", response.results);
                  self.store.setMediaFiles(response?.results)
                  self.totalRows = response._meta.itemCount;
                  self.isLoading = false;
              } else {
                  self.isLoading = false;
              }
          } catch (error) {
              console.error('Failed to fetch mediaFiles', error)
          }
        }),
        fetchFilters: flow(function* fetchFilters(sortParams = {}) {
          self.isLoading = true;

          try {
            const queryParams = {
              ...self.searchParams
            }

            const mediaFileManager = getEnv(self).mediaFileManager
            const response = yield mediaFileManager.fetchFilters(queryParams);
            if (response != null) {
              self.filters = response
              self.isLoading = false;
            } else {
              self.isLoading = false;
            }

          } catch (error) {
            console.error('Failed to fetch all', error)
          }
        }),
        updatePage: function (page) {
            self.page = page
        },
        updatePerPage: function (perPage) {
            self.perPage = perPage
        },
        addSearchParams(param){
            self.searchParams = {...self.searchParams, ...param}
        },
        removeSearchParams(names){
            if(names){
                names.map((name) => delete self.searchParams[name])
            }
        },
    setSelectedGroup(group){  //set selected group to filter parameterSets
      self.selectedGroup = group
    }
    })).views( (self) => ({
      getItems() {
        return self.store.flatList || []
      }
}))
